export function formatId(id: string): string {
  const padded = (id ?? '').padStart(7, '0');
  return `${padded.slice(0, 3)}-${padded.slice(3, 7)}`;
}
